/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
import { functionalColors } from "../utils/functionalColors.js";
var baseColors = {
  brand: '#0374B5',
  link: '#0374B5',
  electric: '#0374B5',
  shamrock: '#0B874B',
  barney: '#BF32A4',
  crimson: '#E0061F',
  fire: '#FC5E13',
  licorice: '#2D3B45',
  oxford: '#394B58',
  ash: '#6B7780',
  slate: '#8B969E',
  tiara: '#C7CDD1',
  porcelain: '#F5F5F5',
  white: '#FFFFFF'
};
var colors = Object.freeze(functionalColors(baseColors));
export default colors;
export { colors };